/** Top-level navigation. Isolated so tests can stub it when jsdom freezes `window.location`. */
export function assignLocationHref(href: string): void {
    window.location.href = href;
}
